import React from "react";

export const Copy = React.forwardRef<SVGSVGElement, React.SVGAttributes<SVGElement>>(function Copy(props, ref) {
	return (
		<svg ref={ref} fill="currentColor" {...props}>
			<use xlinkHref="#icon-copy"></use>
		</svg>
	);
});
